module.exports = __webpack_public_path__ + "static/img/address.1f43f65d.png";